/**
 * Regex to check a dutch date format
 * @type {RegExp}
 */

const dateNL = /^(\d{1,2})(\/|-)(\d{1,2})(\/|-)(\d{4})$/

export default dateNL
